<script setup>
import { toRef } from 'vue';
import { useReportLoading } from '../composables/useReportLoading';

const props = defineProps({
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const visibleLoading = useReportLoading(toRef(props, 'isLoading'));
</script>

<template>
  <slot :visible-loading="visibleLoading" />
</template>
